import React, { useState, useEffect } from 'react'

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

import Currents from './Currents/index'
import Hourly from './Hourly/index'
import Outlook from './Outlook/index'
import useMediaQuery from './hooks/mediaQuery'

import './App.css'
import './styles/fpren.css'

import userLocationInfo from './utils/user-location'

function App() {

  const isSmallMobileDevice = useMediaQuery('(max-width: 576px)')
  const [ location, setLocation ] = useState({ lat: 29.65, lon: -82.32 })


  useEffect(() => {

    async function getLocation() {
      const { latitude: lat, longitude: lon } = await userLocationInfo.getLocation()

      if (!userLocationInfo.doesExist()) {
        const locationDetails = await userLocationInfo.reverseGeocode(location.lat, location.lon)
        userLocationInfo.save(locationDetails)
        setLocation({ lat, lon })
      } else {
        const { lat, lon } = await userLocationInfo.get()
        setLocation({ lat, lon })
      }
    }

    getLocation()

  }, [ location.lat, location.lon ])


  return (
    <div className="app-geoforecast-module">
      <Tabs className="nav-fill" defaultActiveKey="hbh" transition={false} >
        <Tab eventKey="now" title={isSmallMobileDevice ? 'NOW' : 'RIGHT NOW'}>
          <Currents userLocation={[ location.lat, location.lon ]} />
        </Tab>
        <Tab eventKey="hbh" title={isSmallMobileDevice? 'HOUR': 'HOUR-BY-HOUR'}>
          <Hourly userLocation={[ location.lat, location.lon ]}></Hourly>
        </Tab>
        <Tab eventKey="7day" title={isSmallMobileDevice? '7-DAY' : '7-DAY OUTLOOK'}>
          <Outlook userLocation={[ location.lat, location.lon ]}></Outlook>
        </Tab>
      </Tabs>
    </div>
  )
}

export default App